import React from "react";
import { PlanItem } from "./components/PlanItem";
import { ReactComponent as Chevron } from "../../../../assets/icons/chevron.svg";

export const Plans = ({ title, chessPlans, defaultName }) => {
  return (
    <details className="group overflow-hidden rounded-[20px] border border-[#edf1f5] bg-white">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4">
        <div>
          <div className="text-[12px] font-semibold uppercase tracking-[0.12em] text-[#98a2b3]">
            Файлы
          </div>
          <div className="mt-2 text-[22px] font-semibold text-[#101828]">
            {title}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden text-right text-[13px] leading-5 text-[#667085] sm:block">
            {chessPlans.length} {chessPlans.length === 1 ? "файл" : "файлов"}
          </div>
          <div className="flex h-11 w-11 rotate-90 items-center justify-center rounded-full border border-[#edf1f5] bg-white transition-transform duration-300 group-open:-rotate-90">
            <Chevron width="16" height="16" />
          </div>
        </div>
      </summary>

      <ul className="grid gap-2 border-t border-[#edf1f5] p-4 sm:p-5">
        {chessPlans.map((item, index) => (
          <PlanItem
            key={`${item.src}-${index}`}
            item={item}
            defaultName={defaultName}
          />
        ))}
      </ul>
    </details>
  );
};
